<script>
import Layout from "@/router/layouts/main";
import PageHeader from "@/components/page-header";
import axios from "axios";

import TabKompetensiProfesi from "./components/tab-kompetensi-profesi.vue";

export default {
  components: {
    Layout,
    PageHeader,
    TabKompetensiProfesi,
  },

  data() {
    return {
      title: "Detail Approval HCBP",
      BACKEND_URL_VERSION: process.env.VUE_APP_BACKEND_URL_VERSION,
      idWorkOrderAtasan: this.$route.params.id,

      info: {
        loading: true,
        data: {},
      },
    };
  },

  mounted() {
    this.getInfo();
  },

  methods: {
    // ambil info ringkas (kode/keterangan work order, nip, nama peserta, profesi)
    // untuk ditampilkan di bagian info halaman
    getInfo() {
      let self = this;
      self.info.loading = true;
      axios({
        method: "get",
        url:
          self.BACKEND_URL_VERSION +
          "pegawai/pemilihan-kompetensi/approver-hcbp/detail",
        params: { id_work_order_atasan: self.idWorkOrderAtasan },
        headers: {
          Accept: "application/json",
          Authorization: "Bearer " + localStorage.access_token,
        },
      })
        .then((response) => {
          let response_data = response.data;
          if (response_data.meta.code == 200) {
            self.info.data = response_data.data || {};
          }
        })
        .catch((errors) => {
          console.log(errors);
        })
        .finally(() => {
          self.info.loading = false;
        });
    },
    backButton() {
      this.$router.push({ name: "approver-hcbp" });
    },
  },
};
</script>
<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div class="row">
              <!-- bagian navigasi halaman -->
              <div class="col-md-12 d-flex justify-content-between align-item-center">
                <b-button
                  size="sm"
                  variant="danger"
                  class="fw-bold"
                  @click="backButton"
                >
                  <i class="fa fa-arrow-left me-1"></i>
                  Kembali
                </b-button>
              </div>
              <!-- --------------------- -->
            </div>

            <div class="row mt-2">
              <hr />
              <div class="col-12">
                <i class="fas fa-spinner fa-spin" v-if="info.loading"></i>
                <table border="0" class="mb-2" v-else>
                  <tr class="mb-2">
                    <td><b>Kode Work Order</b></td>
                    <td>&nbsp;:&nbsp;</td>
                    <td>{{ info.data?.work_order?.kode || "-" }}</td>
                  </tr>
                  <tr class="mb-2">
                    <td><b>Keterangan</b></td>
                    <td>&nbsp;:&nbsp;</td>
                    <td>{{ info.data?.work_order?.keterangan || "-" }}</td>
                  </tr>
                  <tr class="mb-2">
                    <td><b>NIP</b></td>
                    <td>&nbsp;:&nbsp;</td>
                    <td>{{ info.data?.pegawai_internal?.u_nip || "-" }}</td>
                  </tr>
                  <tr class="mb-2">
                    <td><b>Nama Peserta</b></td>
                    <td>&nbsp;:&nbsp;</td>
                    <td>{{ info.data?.pegawai_internal?.nama || "-" }}</td>
                  </tr>
                  <tr class="mb-2">
                    <td><b>Nama Profesi</b></td>
                    <td>&nbsp;:&nbsp;</td>
                    <td>{{ info.data?.profesi?.nama_profesi || "-" }}</td>
                  </tr>
                  <tr class="mb-2">
                    <td><b>Unit</b></td>
                    <td>&nbsp;:&nbsp;</td>
                    <td>{{ info.data?.pegawai_internal?.unit_lev1?.nama_unitlev1 || "-" }}</td>
                  </tr>
                  <tr class="mb-2">
                    <td><b>Jenjang Jabatan</b></td>
                    <td>&nbsp;:&nbsp;</td>
                    <td>{{ info.data?.work_order_detail?.jenjang_jabatan?.nama_jenjang || "-" }}</td>
                  </tr>
                  <tr class="mb-2">
                    <td><b>Target Kompetensi</b></td>
                    <td>&nbsp;:&nbsp;</td>
                    <td>{{ info.data?.work_order_detail?.target_kompetensi?.target_kompetensi || "-" }}</td>
                  </tr>
                  <tr class="mb-2">
                    <td><b>Level Kompetensi</b></td>
                    <td>&nbsp;:&nbsp;</td>
                    <td>{{ info.data?.work_order_detail?.level_kompetensi?.nama_level || "-" }}</td>
                  </tr>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="col-12">
        <b-tabs class="honor-tabs" nav-class="nav-tabs-custom">
          <b-tab title="Kompetensi Dalam Profesi" active>
            <TabKompetensiProfesi />
          </b-tab>
        </b-tabs>
      </div>
    </div>
  </Layout>
</template>
